import { render, staticRenderFns } from "./translogsocket-detail.vue?vue&type=template&id=7477d15a&scoped=true&"
import script from "./translogsocket-detail.vue?vue&type=script&lang=js&"
export * from "./translogsocket-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7477d15a",
  null
  
)

export default component.exports